
import { createElement } from "react";
import React from "react";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { UpdaterWidget } from "../Common/UpdaterWidget.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Msg } from "./Types.js";

export function View(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    return createElement(UpdaterWidget, {
        FormState: state_1.FormState,
        NotUpdatedFields: ofArray([{
            Description: "",
            Name: "updater.not_update_fields.business_unit",
        }, {
            Description: "",
            Name: "updater.not_update_fields.status",
        }, {
            Description: "",
            Name: "updater.not_update_fields.storage",
        }, {
            Description: "",
            Name: "updater.not_update_fields.qr_code_ids",
        }]),
        OnUploadData: () => {
            dispatch(new Msg(0, []));
        },
        OnUploadFile: (formData) => {
            dispatch(new Msg(2, [formData]));
        },
        Rows: state_1.Rows,
        Title: "updater.tool.title",
        UpdatedFields: ofArray([{
            Description: "",
            Name: "updater.update_fields.display_name",
        }, {
            Description: "",
            Name: "updater.update_fields.manufacturer",
        }, {
            Description: "",
            Name: "updater.update_fields.model",
        }, {
            Description: "",
            Name: "updater.update_fields.serial_number",
        }, {
            Description: "",
            Name: "updater.update_fields.inventory_number",
        }, {
            Description: "",
            Name: "updater.update_fields.comment",
        }, {
            Description: "",
            Name: "updater.update_fields.storage_space",
        }, {
            Description: "",
            Name: "updater.update_fields.last_check",
        }, {
            Description: "",
            Name: "updater.update_fields.next_check",
        }, {
            Description: "",
            Name: "updater.update_fields.categories",
        }, {
            Description: "",
            Name: "updater.update_fields.gurantee_date",
        }, {
            Description: "",
            Name: "updater.update_fields.commercial_comment",
        }, {
            Description: "",
            Name: "updater.update_fields.supplier_article_number",
        }, {
            Description: "",
            Name: "updater.update_fields.supplier",
        }, {
            Description: "",
            Name: "updater.update_fields.custom_fields",
        }]),
    });
}

